export const buildSchoolConfigFromSchool = (school, fallback = null) => {
  if (!school && !fallback) return null

  const source = school || fallback || {}
  const fallbackTheme = fallback?.theme || {}
  const sourceTheme = source?.theme || {}
  const theme = { ...fallbackTheme, ...sourceTheme }

  const actualSchoolName = source?.name || fallback?.schoolName || fallback?.name || ''
  const appName = theme.appName || fallback?.appName || actualSchoolName || 'School'
  const logoUrl = theme.logoUrl || source?.logoUrl || fallback?.logoUrl || null
  const bannerUrl = theme.bannerUrl || source?.bannerUrl || fallback?.bannerUrl || null
  const splashUrl = theme.splashUrl || source?.splashUrl || fallback?.splashUrl || null

  return {
    ...(fallback || {}),
    _id: source?._id || fallback?._id || null,
    schoolCode: source?.schoolCode || fallback?.schoolCode || '',
    name: actualSchoolName || appName,
    schoolName: actualSchoolName || appName,
    appName,
    logoUrl,
    bannerUrl,
    splashUrl,
    theme: {
      ...theme,
      appName,
      logoUrl,
      bannerUrl,
      splashUrl,
    },
    features: source?.features || fallback?.features || undefined,
    admissionFormat: source?.admissionFormat || fallback?.admissionFormat || undefined,
    razorpay: source?.razorpay || fallback?.razorpay || undefined,
  }
}
